import OrderResult from '../components/orderResult/OrderResult';

export default function OrderSuccessPage() {
  return (<OrderResult />);
}
